import * as React from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { MARKET_DATA_LAYER1_CONNECT_CONSENT_LABEL } from "../../constants/marketDataDisclaimers";
import {
  BROKER_FIELD_DESC_CLASS,
} from "@/components/Broker/brokerAlertUi";
import { cn } from "@/lib/utils";

export type MarketDataFetchConsentCheckboxProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
};

export function MarketDataFetchConsentCheckbox({
  id,
  checked,
  onCheckedChange,
  className,
}: MarketDataFetchConsentCheckboxProps): React.ReactElement {
  return (
    <Label
      htmlFor={id}
      className={cn("flex cursor-pointer items-start gap-2 font-normal", className)}
    >
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onCheckedChange(value === true)}
        className="mt-0.5"
      />
      <span className={cn(BROKER_FIELD_DESC_CLASS, "leading-5")}>
        <span className="font-normal text-gray-500">(Optional) </span>
        {MARKET_DATA_LAYER1_CONNECT_CONSENT_LABEL}
      </span>
    </Label>
  );
}

export function brokerRequiresMdFetchConsent(brokerSlug: string): boolean {
  const normalized = brokerSlug.trim().toLowerCase();
  return normalized === "ctrader" || normalized === "liquidbrokers" || normalized === "liquid";
}